var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinancialYear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2349 5.52346H29.0945L29.094 3.73774C29.094 3.14583 28.6142 2.66651 28.0228 2.66651L25.3671 2.66602C24.7757 2.66602 24.2959 3.14533 24.2959 3.73724V5.52297L14.7246 5.52346V3.73774C14.7246 3.14583 14.2453 2.66651 13.6534 2.66651H10.9982C10.4063 2.66651 9.92701 3.14583 9.92701 3.73774V5.52346H7.78657C4.96296 5.52346 2.66602 7.82041 2.66602 10.644V30.8788C2.66602 33.7024 4.96296 35.9993 7.78657 35.9993H31.2356C34.0592 35.9993 36.3562 33.7024 36.3562 30.8788V10.644C36.3562 7.82041 34.0585 5.52346 31.2349 5.52346ZM34.2125 30.8794C34.2125 32.5217 32.8777 33.8575 31.2344 33.8575L7.78536 33.857C6.14313 33.857 4.80729 32.5212 4.80729 30.8789L4.80779 13.9758H34.2135V30.8789L34.2125 30.8794Z",
    fill: "#10B981"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 17C16.1389 17 13 20.1389 13 24C13 27.8611 16.1389 31 20 31C23.8611 31 27 27.8611 27 24C27 20.1389 23.8611 17 20 17ZM22.5494 21.5684H21.0758C21.2674 21.8336 21.4 22.1432 21.4737 22.4674H22.5494V23.5284L21.4737 23.5283C21.2379 24.6483 20.2358 25.4883 19.0422 25.4883H18.7916L21.5916 28.3325L20.0296 28.3326L17.4506 25.7242V24.3684H19.0422C19.6169 24.3684 20.1032 24.0147 20.3096 23.5283H17.4506V22.4673H20.3096C20.1033 21.9663 19.6169 21.6272 19.0422 21.6272L17.4506 21.6273V20.5074H22.5348V21.5684L22.5494 21.5684Z",
    fill: "#10B981"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinancialYear);
export default __webpack_public_path__ + "static/media/FinancialYear.b902b7be663ca1a2ee88a46fc8097aa5.svg";
export { ForwardRef as ReactComponent };